var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1180_3135)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1180_3135)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.75,
    fill: "#EAF0FF",
    stroke: "#2468FF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1180_3135)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1709 7.61441C13.3879 7.39745 13.3879 7.04569 13.1709 6.82873C12.954 6.61178 12.6022 6.61178 12.3853 6.82873L10.0003 9.21368L7.61538 6.82873C7.39843 6.61178 7.04667 6.61178 6.82971 6.82873C6.61275 7.04569 6.61275 7.39745 6.82971 7.61441L9.21465 9.99935L6.82971 12.3843C6.61275 12.6012 6.61275 12.953 6.82971 13.17C7.04667 13.3869 7.39843 13.3869 7.61538 13.17L10.0003 10.785L12.3853 13.17C12.6022 13.3869 12.954 13.3869 13.1709 13.17C13.3879 12.953 13.3879 12.6012 13.1709 12.3843L10.786 9.99935L13.1709 7.61441Z",
    fill: "#2468FF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1180_3135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1180_3135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1180_3135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.66667,
    height: 6.66667,
    fill: "white",
    transform: "translate(6.66699 6.66602)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.de353af646d7d06dff4a9f796c1a45c9.svg";
export { ForwardRef as ReactComponent };